var formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var swiperObject = {};

/* ============== intersection observe Swiper ============== */
const observerSwiper = new IntersectionObserver(function (entries, self) {
  entries.forEach(entry => {
    let elid;
    if (entry.isIntersecting) {
      elid = entry.target.id;
    }
    if (elid && !entry.target.classList.contains("swiper-initialized")) {
      const slideCount = entry.target.querySelectorAll('.swiper-slide').length;
      const loopEnabled = slideCount > 1;
      swiperObject[entry.target.id] = new Swiper('[id^="' + entry.target.id + '"]', {
        speed: 400,
        grabCursor: true,
        loop: loopEnabled,
        pagination: {
          el: '.swiper-pagination',
          horizontalClass: 'custom-collection-navigation',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    } else {
       if (entry.target.classList.contains("swiper-initialized")) {
        if (swiperObject[entry.target.id] && typeof swiperObject[entry.target.id].destroy === 'function') {
          swiperObject[entry.target.id].destroy(true, true);
        }
        delete swiperObject[entry.target.id];
      }
    }
  });
}, {
  root: null,
    threshold: 0.2,
      rootMargin: '50px'
});

/* ============== intersection observe Swiper: init ============== */
const initOberverReveal = () => {
  let elsSwiper = document.querySelectorAll('.product-item__image__carousel');
  elsSwiper.forEach((el) => {
    observerSwiper.observe(el);
  });
}
window.addEventListener('load', initOberverReveal);
window.addEventListener('filterActivated', initOberverReveal);
window.addEventListener('loadMoreAppended', initOberverReveal);





document.addEventListener("DOMContentLoaded", function (event) {
  liquidAjaxCart.conf("quantityTagAllowZero", true);
  liquidAjaxCart.conf("updateOnWindowFocus", false);


  $('.product-item__figure__form__plus').on('click', function () {
    $(this).parent().find('.product-item__figure__form').addClass('product-item__figure__form--active');
    $(this).hide();
  });
  $('.product-item__figure__form__minus').on('click', function () {
    $(this).parent().removeClass('product-item__figure__form--active');
    $(this).parent().parent().find('.product-item__figure__form__plus').show();
  });


  const initCartSwiper = () => {
    if (typeof Swiper !== 'undefined' && document.querySelector('.shpcd-cart__carrusel__slider')) {
      new Swiper('.shpcd-cart__carrusel__slider', {
        speed: 400,
        grabCursor: true,
        loop: true,
        spaceBetween: 10,
        slidesPerView: 2.3,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        pagination: {
          el: '.swiper-pagination',
          horizontalClass: 'custom-collection-navigation',
        },
        navigation: {
          nextEl: '.swiper-button-next--cart',
          prevEl: '.swiper-button-prev--cart',
        },
        breakpoints: {
          900: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        }
      });
    } else {
      setTimeout(initCartSwiper, 100);
    }
  };
  initCartSwiper();
});

// Remove o 'klarna-placement' do DOM
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const promoBadge = document.querySelector("klarna-placement");

    if (promoBadge) {
      const parentElement = promoBadge.parentNode;

      parentElement.removeChild(promoBadge);
      const klarnaElement = document.querySelector('.KlarnaInfoPageOnSiteMessagingAppElement');

      if (klarnaElement) {
        klarnaElement.appendChild(promoBadge);
      }
    }
  }, 1500); 
});


document.addEventListener('DOMContentLoaded', function () {

  let onKlaviyoSizeChange = function(evt){
      evt.preventDefault();
      $(this).parent().find("input + label").trigger('click');
  }
  
  $('.product-option__fieldset___option__input[name=id] ~ .klaviyo-bis-trigger').on('click', onKlaviyoSizeChange); //Registering on submit.
});

document.addEventListener('liquid-ajax-cart:request-end', function() {
  const wishlistElements = document.querySelectorAll('[wk-id]');
  wishlistElements.forEach(element => {
    const parent = element.parentNode;
    if (parent) {
      const nextSibling = element.nextSibling;
      parent.removeChild(element);
      if (nextSibling) {
        parent.insertBefore(element, nextSibling);
      } else {
        parent.appendChild(element);
      }
    }
  });
});
